// extracted by mini-css-extract-plugin
module.exports = {"norecords_text":"ImagesTable_norecords_text__E4idi","greenTable":"ImagesTable_greenTable__3ISr_","errorRecord":"ImagesTable_errorRecord__Jhnez"};